import {formValidationProps, useFormValidation} from "@/components/organisms/mixins/form-validation.mixin";

export const infosFacturationProFormProps = () => ({
  checkout: {
    type: Object,
    required: true
  },
  modelInitial: {
    type: Object,
    required: true
  },
  infoNonRetrait: {
    type: String,
    required: false,
    default: null
  },
  ...formValidationProps()
})

export const infosFacturationProFormEmits = () => ([
  "save",
  "displayCgv",
  "update"
])

export const useInfosFacturationProForm = (props, context, confirmationRef) => {

  const {
    nbValidations,
    captcha,
    v$,
    getState,
    getErrorMessage,
    scrollToFirstError,
    checkValidation,
    states,
    isError,
    isSuccess,
    isLoadingComputed,
    errorsArray
  } = useFormValidation(props)

  const model = ref({
    pro_ref: "",
    pro_passee_par: "",
    pro_beneficiaire: "",
    pro_adr_beneficiaire: "",
    cg_ok: true
  });

  const askConfirm = (v) => {
    if (checkValidation(v)) {
    confirmationRef.value.show();
    }
  }
  const save = (v) => {
   
    if (checkValidation(v)) {
    confirmationRef.value.hide();
    context.emit("save");
    }
  }
  const hydrateModel = () => {
    model.value.pro_ref = props.modelInitial.pro_ref;
    model.value.pro_passee_par = props.modelInitial.pro_passee_par;
    model.value.pro_beneficiaire = props.modelInitial.pro_beneficiaire;
    model.value.pro_adr_beneficiaire = props.modelInitial.pro_adr_beneficiaire;
    model.value.cg_ok = props.modelInitial.cg_ok;
  }
  const displayCgv = (e) => {
    e.preventDefault();
    context.emit('displayCgv');
  }

  watch(
    () => model.value,
    (val) => {
      context.emit('update', val);
    }, { deep: true }
  )

  return {
    model,
    askConfirm,
    save,
    hydrateModel,
    displayCgv,
    nbValidations,
    captcha,
    v$,
    getState,
    getErrorMessage,
    scrollToFirstError,
    checkValidation,
    states,
    isError,
    isSuccess,
    isLoadingComputed,
    errorsArray 
  }
}